import React, { useState, useEffect } from 'react';
// import './waveAnimation.css';
import {
  githubIcon,
  linkedinIcon,
  youtubeIcon,
  myEmailId,
  myPhoto,
  myLocation,
  myName,
  myLinkedInURL,
  myGitHubURL,
  myYoutubeURL,
  buttonColor,
} from './constants';
import {
  FaLocationArrow,
  FaEnvelope,
  FaCopy,
  FaCheckCircle,
} from 'react-icons/fa';

const ContactLinks = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [successMessage, setSuccessMessage] = useState({
    visible: false,
    text: '',
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize(); // Check initial width
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const containerStyles = isMobile ? styles.containerMobile : styles.container;
  const linkBoxStyles = isMobile ? styles.linkBoxMobile : styles.linkBox;
  const imageBoxStyles = isMobile ? styles.imageBoxMobile : styles.imageBox;

  const handleCopyToClipboard = () => {
    navigator.clipboard
      .writeText(myEmailId)
      .then(() => {
        setSuccessMessage({
          visible: true,
          text: 'Copied to clipboard!',
        });
        setTimeout(() => {
          setSuccessMessage({
            visible: false,
            text: '',
          });
        }, 3000);
      })
      .catch((error) => {
        console.error('Failed to copy URL to clipboard:', error);
      });
  };

  return (
    <div style={containerStyles}>
      <div style={linkBoxStyles}>
        <h2>{myName}</h2>
        <p>
          <FaLocationArrow color={buttonColor} />
          &nbsp; {myLocation}
        </p>
        <br />
        <div style={styles.iconSection}>
          <a href={myLinkedInURL} target='_blank' rel='noopener noreferrer'>
            <img src={linkedinIcon} alt='Linkedin' style={styles.iconImage} />
          </a>
          &nbsp;
          <a href={myGitHubURL} target='_blank' rel='noopener noreferrer'>
            <img src={githubIcon} alt='GitHub' style={styles.iconImage} />
          </a>
          &nbsp;
          <a href={myYoutubeURL} target='_blank' rel='noopener noreferrer'>
            <img src={youtubeIcon} alt='Youtube' style={styles.iconImage} />
          </a>
          &nbsp;
          {/* <a href={myInstagramURL} target='_blank' rel='noopener noreferrer'>
            <img src={instagramIcon} alt='Instagram' style={styles.iconImage} />
          </a> */}
        </div>
        <br />
        <div style={{ paddingBottom: '5px' }}>
          <a href='mailto:gunasekaran.v@northeastern.edu'>
            <FaEnvelope color={buttonColor} />
          </a>
          &nbsp;
          {myEmailId}
          &nbsp;
          <a>
            <FaCopy color={buttonColor} onClick={handleCopyToClipboard} />
          </a>
        </div>
      </div>
      <div style={imageBoxStyles}>
        <img src={myPhoto} alt='My Picture3' style={styles.myImage} />
      </div>

      {successMessage.visible && (
        <div style={styles.successMessage}>
          <div style={styles.successIcon}>
            <FaCheckCircle style={styles.successIconCircle} />
          </div>
          <div style={styles.successText}>{successMessage.text}</div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    // minHeight: '30vh', // 30% of the viewport height
    width: '60%',
    marginRight: '10px',
    border: '1px solid black',
    background: 'white',
  },
  containerMobile: {
    // display: 'flex',
    // flexDirection: 'column',
    // alignItems: 'center',
    // justifyContent: 'center',
    // minHeight: '30vh', // 30% of the viewport height
    // width: '100%',
    // marginRight: '10px',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    alignSelf: 'center',
    // border: '1px solid black',
  },
  linkBox: {
    width: '50%',
    // height: '70%',
    // border: '1px solid black',
    position: 'relative',
    overflow: 'hidden',
    // display: 'flex',
    // flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    // border: '1px solid blue',
  },
  linkBoxMobile: {
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  iconSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconImage: {
    width: 30,
    height: 30,
  },
  imageBox: {
    width: '50%',
    // alignItems: 'center',
    // justifyContent: 'center',
    textAlign: 'center',
    // border: '1px solid orange',
  },
  imageBoxMobile: {
    // width: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    // border: '1px solid orange',
  },
  myImage: {
    // width: 240 / 2,
    // height: 440 / 2,
    // height: '100%',
    // width: 'auto',
    width: '40%', // Adjust the width percentage as needed
    // height: 'auto', // This will maintain the image's aspect ratio
    // height: '10%',
    imageRendering: 'crisp-edges', // Ensures the image retains its sharpness
    objectFit: 'contain', // Adjust the object-fit property as needed
    borderRadius: '10px',
  },
  successMessage: {
    position: 'fixed',
    bottom: '80px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#000',
    color: '#fff',
    borderRadius: '5px',
    padding: '10px 20px',
    zIndex: 9999,
  },
  successIcon: {
    marginRight: '10px',
  },
  successIconCircle: {
    color: 'green',
    fontSize: '18px',
  },
  successText: {
    fontSize: '14px',
  },
};

export default ContactLinks;
